import './ErrorPage.scss';
import { useLocation, useParams } from 'react-router';
import Header from '../../components/Header/Header';
import TwoColumnLayout from '../../components/TwoColumnLayout/TwoColumnLayout';
import ErrorPageSide from './ErrorPageSide/ErrorPageSide';
import NotFoundErrorPageBody from './ErrorPageBody/NotFoundErrorPageBody';
import LoadingErrorPageBody from './ErrorPageBody/LoadingErrorPageBody';
import SubmitErrorPageBody from './ErrorPageBody/SubmitErrorPageBody';
import RetrievalErrorPageBody from './ErrorPageBody/RetrievalErrorPageBody';
import Metadata from '../../components/Metadata/Metadata';

function ErrorPage(): React.JSX.Element {
  
    const errorType = useLocation().pathname.replace('/', '');

  return (
    <>
      <Metadata
        title='Error | Newcastle Permanent'
        description="Something's gone wrong. It might just be having a moment, so please try again later or head back to our website and get in touch for help."
      />
      <Header>
        {((): React.JSX.Element => {
          switch (errorType) {
            case '404':
              return <>404 error</>;
            case 'retrieval-error':
              return <>Retrieval error</>;
            case 'submit-error':
              return <>Submit error</>;
            case 'loading-error':
              return <>Loading error</>;
            default:
              return <>Oops</>;
          }
        })()}
      </Header>
      <main className='error-page'>
        <TwoColumnLayout
          rightColumn={((): React.JSX.Element => {
            return <ErrorPageSide />;
          })()}
        >
          {((): React.JSX.Element => {
            switch (errorType) {
              case '404':
                return <NotFoundErrorPageBody />;
              case 'retrieval-error':
                return <RetrievalErrorPageBody />;
              case 'submit-error':
                return <SubmitErrorPageBody />;
              case 'loading-error':
              default:
                return <LoadingErrorPageBody />;
            }
          })()}
        </TwoColumnLayout>
      </main>
    </>
  );
}

export default ErrorPage;
